// extracted by extract-css-chunks-webpack-plugin
module.exports = {"pageViewer":"pageViewer-2sQ9z","hoverScale":"hoverScale-Jxf2F","scaleAnimation":"scaleAnimation-35499","caption":"caption-4MKDv"};